import React from "react";

export default function renderIcon({
  width = 22,
  height = 22,
  color = "#848484",
}) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      className="arrow-next2-icon"
    >
      <style>{`
        .arrow-next2-icon circle {
          transition: fill 0.2s, fill-opacity 0.2s;
        }
        .arrow-next2-icon:hover circle {
          fill: #7B47D2;
          fill-opacity: 1;
        }
      `}</style>
      <circle
        cx="30"
        cy="30"
        r="29.65"
        fill="black"
        fillOpacity="0.4"
        stroke="white"
        strokeWidth="0.7"
      />
      <path
        d="M34.7969 29.1084L27.5246 22.1806C27.4032 22.0647 27.2418 22 27.074 22C26.9062 22 26.7448 22.0647 26.6234 22.1806L26.6173 22.1887C26.5582 22.2447 26.511 22.3122 26.4788 22.3871C26.4466 22.4619 26.43 22.5425 26.43 22.624C26.43 22.7055 26.4466 22.7861 26.4788 22.861C26.511 22.9358 26.5582 23.0033 26.6173 23.0593L33.4636 29.5834L26.6173 36.1035C26.5582 36.1595 26.511 36.227 26.4788 36.3018C26.4466 36.3766 26.43 36.4573 26.43 36.5387C26.43 36.6202 26.4466 36.7008 26.4788 36.7757C26.511 36.8505 26.5582 36.918 26.6173 36.974L26.6234 36.9822C26.7448 37.0981 26.9062 37.1628 27.074 37.1628C27.2418 37.1628 27.4032 37.0981 27.5246 36.9822L34.7969 30.0544C34.8611 29.9934 34.9122 29.9201 34.9471 29.8388C34.982 29.7574 35 29.6699 35 29.5814C35 29.4929 34.982 29.4053 34.9471 29.324C34.9122 29.2427 34.8611 29.1693 34.7969 29.1084Z"
        fill="white"
      />
    </svg>
  );
}
